// extracted by mini-css-extract-plugin
export default {"head":"popular-times__head___1vk-v","title":"popular-times__title___1EfqN","time-message":"popular-times__time-message___1hNyd","disclaimer":"popular-times__disclaimer___33GSH"};